import React, { useState } from "react";
import Layout from "../form-layout";

const OPTIONS = [
  "I would like my treatment to be overseen by an expert weight-loss doctor",
  "More competitive treatment costs",
  "Stocking issues with my current provider",
  "I would like more clinical support and guidance with my treatment",
  "I am looking for a better overall service and experience",
  "I have experienced delivery or prescription delays",
  "I would like to change or review my current treatment",
];

// Form B Q7 — "Why have you chosen to transfer your care to Slimming Doctor?" Last of
// Form B's own questions; rejoins the shared core question set (age gate onward) that
// Form A also uses.
export default function TransferReason({ formData, setFormData, onBack, goToStep }) {
  const [selected, setSelected] = useState(formData.transferReasons || []);
  const [otherText, setOtherText] = useState(formData.transferReasonOther || "");

  const toggle = (reason) => {
    setSelected((prev) => (prev.includes(reason) ? prev.filter((r) => r !== reason) : [...prev, reason]));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selected.length === 0) return;
    if (selected.includes("Other") && !otherText.trim()) return;

    setFormData((prev) => ({
      ...prev,
      transferReasons: selected,
      transferReasonOther: otherText,
    }));
    localStorage.setItem("transferReasons", JSON.stringify(selected));
    localStorage.setItem("transferReasonOther", otherText);

    goToStep("ageGate");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-2">
        Why have you chosen to transfer your care to Slimming Doctor?
      </h2>
      <p className="text-gray-500 mb-6 text-sm">Please select all that apply.</p>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {OPTIONS.map((option) => (
          <label key={option} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => toggle(option)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{option}</span>
          </label>
        ))}

        <label className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
          <input
            type="checkbox"
            checked={selected.includes("Other")}
            onChange={() => toggle("Other")}
            className="h-4 w-4 accent-sky-400 cursor-pointer"
          />
          <span>Other — please specify</span>
        </label>
        {selected.includes("Other") && (
          <input
            type="text"
            value={otherText}
            onChange={(e) => setOtherText(e.target.value)}
            placeholder="Please specify"
            className="border-2 border-sky-400 rounded-md p-2 text-sm w-full"
          />
        )}

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            disabled={selected.length === 0 || (selected.includes("Other") && !otherText.trim())}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                selected.length === 0 || (selected.includes("Other") && !otherText.trim())
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
